import React, { useState } from "react";
import { Link } from "gatsby";
import MobileNavigation from "./Navigation/MobileNavigation";
import FullNavigation from "./Navigation/FullNavigation";
import Logo from "../assets/images/reeddilogo.png";

import ReeddiMenu from "../assets/images/navbar/reeddi_menu.png";
import TempOwnMenu from "../assets/images/navbar/tempown_menu.png";
import BigEnergyMenu from "../assets/images/navbar/bigenergy-menu.png";
import EnergyBoxMenu from "../assets/images/navbar/energybox-menu.png";

const isBrowser = () => typeof window !== "undefined";

const navigation = [
  {
    name: "Products",
    href: undefined,
    menu: true,
    menuItems: [
      {
        name: "Reeddi Capsule",
        desc: "200W Mobile and Clean Electricity, Anytime and Anywhere",
        img: ReeddiMenu,
        href: "/reeddi-capsule",
      },
      {
        name: "Reeddi EnergyBox",
        desc: "More Electricity for Households and Businesses",
        img: EnergyBoxMenu,
        href: "/reeddi-energybox",
      },
      {
        name: "Reeddi BigEnergy",
        desc: "Bigger Electricity for your Homes and Businesses",
        img: BigEnergyMenu,
        href: "/reeddi-bigenergy",
      },
      {
        name: "TempOwn",
        desc: "Digital Rental Infrastructure",
        img: TempOwnMenu,
        href: "https://www.tempown.com",
        target: "_blank",
      },
    ],
  },
  { name: "About Us", href: "/about", menu: false },
  {
    name: "Learn",
    href: undefined,
    menu: true,
    menuItems: [
      {
        name: "Renting Our Reeddi Products",
        href: "/rent-a-capsule",
        target: "",
      },
      {
        name: "Becoming an Ambassador",
        href: "/ambassador",
        target: "",
      },
      {
        name: "Impact Of Our Solution",
        href: "/awards",
        target: "",
      },
      {
        name: "Pay In Installments",
        href: "/pay-in-installments",
        target: "",
      },
      {
        name: "Our Research",
        href: "/research",
        target: "",
      },
      {
        name: "Articles",
        href: "https://medium.com/@getreeddi",
        target: "_blank",
      },
      {
        name: "Rental Policy",
        href: "/rental-policy",
        target: "",
      },
    ],
  },
  { name: "Media", href: "/media", menu: false },
  { name: "Career", href: "/career", menu: false },
];

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <div
      className={`${
        mobileOpen ? "bg-[white]" : "bg-white filter-blur-backdrop"
      } sticky top-0 w-full z-30 pt-2 pb-2 border-0`}>
      <div className="w-11/12 max-w-7xl mx-auto">
        <div className="relative flex items-center justify-end sm:justify-between h-16">
          <div className="flex-1 flex items-center justify-between sm:items-stretch">
            <Link to="/" className="pt-1 no-click-highlight">
              <img
                className="block w-20 no-click-highlight"
                src={Logo}
                alt="Reeddi"
              />
            </Link>
            <FullNavigation
              isBrowser={isBrowser}
              navigation={navigation}
              classNames={classNames}
            />
          </div>
          <div className="sm:hidden">
            {/* Mobile menu button*/}
            <MobileNavigation
              open={mobileOpen}
              setOpen={setMobileOpen}
              isBrowser={isBrowser}
              navigation={navigation}
              classNames={classNames}
            />
            {/* Mobile menu*/}
          </div>
        </div>
      </div>
    </div>
  );
}
